import React from 'react';
import { css } from '@emotion/css';
import * as fns from 'date-fns';
import { Chip } from '@mui/material';
import { colors } from 'styles/colors';

type TimeSelectorProps = {
    selectedTime?: Date | null
    availableTime?: Date[]
    onSelectTime?: (time: Date) => void
}

const TimeSelector = ({ selectedTime, availableTime, onSelectTime }: TimeSelectorProps) => {
    return (
        <div className={styles.timeRows}>
            {availableTime?.sort()?.map((time, idx) => {
                const selected = !!selectedTime && fns.isSameSecond(selectedTime, time);
                return (
                    <Chip
                        key={idx}
                        onClick={() => onSelectTime && onSelectTime(time)}
                        label={fns.format(time, 'HH:mm')}
                        sx={{
                            ...styles.chipBase,
                            ...(selected ? styles.chipSelected : styles.chipUnselected),
                        }}
                    />
                );
            })}
        </div>
    );
};

const styles = {
    timeRows: css({
        flex: 1,
        maxWidth: '15rem',
        minHeight: '4.5rem',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: '0.5rem',
    }),
    chipBase: {
        borderRadius: '4px',
        minWidth: '6rem',
        height: '2.6rem',
        fontSize: '0.95rem',
        fontWeight: 500,
        letterSpacing: '0.5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        flex: '0 0 auto',
        transition: 'background-color 0.18s ease, color 0.18s ease, border-color 0.18s ease',
        '.MuiChip-label': {
            width: '100%',
            paddingLeft: '0.5rem',
            paddingRight: '0.5rem',
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
        },
    },
    chipUnselected: {
        backgroundColor: colors.white,
        color: colors.primaryText,
        border: `1px solid ${colors.lightGrey}`,
        '&:hover': {
            backgroundColor: colors.lighterGrey,
        },
    },
    chipSelected: {
        backgroundColor: colors.primary,
        color: colors.primaryTextLight,
        border: `1px solid ${colors.primary}`,
        boxShadow: '0 0 0 2px rgba(0,0,0,0.04)',
        '&:hover': {
            backgroundColor: colors.primary,
        },
    },
};

export default TimeSelector;
